import { render, staticRenderFns } from "./count.vue?vue&type=template&id=bebab9b4&scoped=true&"
import script from "./count.vue?vue&type=script&lang=js&"
export * from "./count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebab9b4",
  null
  
)

export default component.exports